import mTypes from '@/store/mutation_types'

export default {
    [mTypes.SET_USERS](state, payload) {
        state.allUsers = payload;
    },
    [mTypes.SET_USER_EMAIL](state, payload) {
        state.user.user_email = payload;
    },
    [mTypes.SET_TAXI_TYPES](state, payload) {
        state.taxi_types = payload;
    },
    [mTypes.SET_BUSES](state, payload) {
        state.buses = payload;
    },
    [mTypes.SET_TRAVEL_OFFERS](state, payload) {
        state.travel_offers = payload;
    },
    [mTypes.SET_TAXI_REQUESTS](state, payload) {
        state.taxi_requests = payload;
    },
    [mTypes.SET_FEEDBACK](state, payload) {
        state.feedback = payload;
    },
}

